import { z } from 'zod';

import { Product, ProductSchema } from './product';
import { ElementType } from './utils';
import {
  Enum_Modules_Type,
  GalleryFragment,
} from '../graphql/generated/graphql';
import { ValidationError } from '../utils/errors';

export const StoryComponentSchema = z.object({
  __typename: z.literal('ComponentContentStory'),
  Story: z
    .object({
      id: z.string(),
      Status: z.string(),
    })
    .passthrough(),
});

export type StoryComponent = ElementType<
  GalleryFragment['Content'] & {
    __typename: 'ComponentContentStory';
  }
> &
  z.infer<typeof StoryComponentSchema>;

export const GallerySchema = z
  .object({
    __typename: z.literal('Modules'),
    Type: z.literal(Enum_Modules_Type.Stories),
    Product: ProductSchema,
    Content: StoryComponentSchema.array().nonempty(),
  })
  .passthrough();

type GallerySchema = z.infer<typeof GallerySchema>;

export type Gallery = Omit<GalleryFragment, 'Content' | 'Product'> & {
  Content: StoryComponent[];
  Product: Product;
} & z.infer<typeof GallerySchema>;

export const isGallery = (
  gallery: unknown,
  strict = true
): gallery is Gallery => {
  const result = GallerySchema.safeParse(gallery);
  if (strict && !result.success) {
    throw new ValidationError(
      `Invalid gallery: ${JSON.stringify(gallery)}` +
        '\n' +
        `Issues: ${JSON.stringify(result.error.issues)}`
    );
  }
  return result.success;
};
